import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am a Computer Science student passionate about building functional and reliable technology solutions. After exploring various technologies, I have solidified my strong interest in backend development.
              <br />
              <br />
              I am proficient in 
              <i>
                <b className="purple">
                  {" "}
                  Golang, PHP, Laravel, and MySQL{" "}
                </b>
              </i>
              . I also have full-stack experience using 
              <i>
                <b className="purple">
                  {" "}
                  React.js, Blade, and Tailwind CSS,{" "}
                </b>
              </i>
              complemented by UI/UX design skills in 
              <i>
                <b className="purple"> Figma</b>
              </i>.
              <br />
              <br />
              My primary focus is developing 
              <i>
                <b className="purple">
                  {" "}
                  scalable backend systems and efficient web applications.{" "}
                </b>
              </i>
              I have strong, hands-on experience building RESTful APIs using 
              <b className="purple"> Laravel (PHP) </b> backend and am highly enthusiastic about developing high-performance systems with{" "}
              <i>
                <b className="purple">Golang</b>.
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;